import React from 'react';

export const pageMeta = {
  "name": "JS News 2025-2015",
  "link": "/javascript/news"
};

export default function JavascriptNews() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">JS News 2025-2015</h2>
      <p>Route: /javascript/news</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
